import axios from 'axios';
import StaticVar from '../Config/StaticVar';

const axiosInstance = axios.create({
  baseURL: StaticVar.URL_API, // Ganti sesuai base URL API kamu
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

const getResultData = async (event_id, participant_id) => {
  const response = await axiosInstance.get(`/result?event_id=${event_id}&participant_id=${participant_id}`);
  console.log('response getResultData', response.data)
  return response.data;
};

const getCertificateData = async (event_id) => {
  const response = await axiosInstance.get(`/result/certificate?event_id=${event_id}`);
  console.log('response getResultData', response.data)
  return response.data;
};

const getEventList = async (data) => {
  const response = await axiosInstance.get(`/result/events`, data);
  console.log('response getResultData', response.data)
  return response.data;
};

const api = {
    getResultData,
    getCertificateData,
    getEventList
};

export default api;
